import React from "react";
import { path } from "ramda";
import { Row, Col, Card, Popover } from "antd";
import styled, { withTheme, css } from "styled-components";
import { ThemeHelper } from "../../hoc/with/withThemeProvider";
import I18n, { fromSyntax } from "../../i18n";
import Metrics from "../../theme/Metrics";
import Color, { DataVisualizeKeys } from "../../theme/Colors";
import { isFunction } from "../../util";
import { SimpleText, SingleLine } from "../text/OText";

const selectedBar = (props)=>`
    background-color:${ThemeHelper.getMainVisualizeColor(props, 0, props.colorType)};
    color: #FFF;
    border-style: solid;
    border-width: ${Metrics.thinBorderWidth}px;
    border-color:  ${ThemeHelper.getVisualizeFromProp(props,"data_border", props.colorType)};
    box-shadow: 0 0 4px 0 ${ThemeHelper.getVisualizeFromProp(props,"data_border", props.colorType)};
`;
const Bar = styled.div`
    min-height:50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-size: ${Metrics.fontSize.header}px;
    width: ${props => 100 * props.BarWidth}%;
    border-radius: 12px;

    ${props=>props.selected ? selectedBar(props) :`
        background-color:${Color.greyBackgroundColor};
        color: ${Color.transparent};
    `}
    ${props=>props.nonHover ? "" : `
        &:hover{${selectedBar(props)}}
    `}
`;
const EmptyBar = styled.div`
    min-height:50px;
`;
const VerticalBarGraph = (props) => {
	const { 
		style = undefined,
		value,
		index = 0,
		selectChoiceIndex = -1,
		onChoiceClick,
		colorType = DataVisualizeKeys.Primary,
		nonHover = false,
		showChoice = false,
		shortQuestion = true,
	} = props;
	const dizColor = path(["theme", "data_visualize", colorType, "main"], props);

	return (<div>
		<h2>{value.title}</h2>
		<SimpleText singleLine={shortQuestion} title={value.question} fontSize={Metrics.fontSize.content}>
            "{value.question}"
		</SimpleText>
		{value.choices.map((Ch,C_Index)=>{
			let choiceText = `${fromSyntax(I18n.t("choice_path_syntax"), {index:C_Index+1})}`;
			choiceText = choiceText[0].toLowerCase()+choiceText.slice(1);
			return <div key={C_Index} 
				title={Ch.value} 
				style={{paddingBottom:4}} 
				onClick={ isFunction(onChoiceClick) && Ch.value > 0 ? ()=>onChoiceClick(index, C_Index) : undefined} >
				<SingleLine title={Ch.text} fontSize={Metrics.fontSize.hint} color={Color.lightFontColor}>
					{`${choiceText} ${showChoice ? `"${Ch.text}"` : ""}`}
				</SingleLine>
				<div style={{width:"100%"}}>
					{(Ch.ratio< 0.1) || isNaN(Ch.ratio)? 
						Ch.value === 0 ? 
							<EmptyBar>
								<p style={{color:Color.unimportantFontAlphaColor}}>
									{I18n.t("noone_chooses_choice")}
								</p>
							</EmptyBar> :
							<Popover placement="right" content={
								<p>{Ch.value}</p>
							} >
								<Bar //nonHover={!isFunction(onChoiceClick)} 
									colorType={colorType} 
									selected={C_Index === selectChoiceIndex} 
									BarWidth={Ch.ratio} />
							</Popover>
						:
						<Bar //nonHover={!isFunction(onChoiceClick)} 
							colorType={colorType} 
							selected={C_Index === selectChoiceIndex} 
							BarWidth={Ch.ratio}>{Ch.value}</Bar>
					}
				</div>
			</div>;
		})}
	</div>);
};

export const VerticalGraphValue = withTheme(VerticalBarGraph);

const BarChart = (props) => {
	const { value,
		nonPadding = false,
		onQuestionClick,
		colProps = { md: 24, lg:12 }, 
	} = props;
	return (
		<Row gutter={Metrics.button.bigSpaceMargin}>
			{props.questions.map((value, index) =>(
				<Col key ={index} style={{ paddingBottom: `${Metrics.button.bigSpaceMargin}px` }}
					onClick={isFunction(onQuestionClick) ? ()=>{onQuestionClick(index);} : undefined}
					{...colProps} >
					<Card>
						<VerticalGraphValue value={value} index={index} />
					</Card>
				</Col>)
			)}
		</Row>
	);
};
export default BarChart;






// WEBPACK FOOTER //
// ./src/components/chart/BarChart.js